import { useEffect, useState } from 'react';

const HOURS_ONLY_BELOW_MS = 24 * 60 * 60 * 1000;

export function formatCampaignCountdown(remainingMs: number): string | null {
  if (!Number.isFinite(remainingMs) || remainingMs <= 0) return null;

  if (remainingMs >= HOURS_ONLY_BELOW_MS) {
    const days = Math.floor(remainingMs / HOURS_ONLY_BELOW_MS);
    const hours = Math.floor((remainingMs % HOURS_ONLY_BELOW_MS) / (60 * 60 * 1000));
    return hours > 0 ? `${days}d ${hours}h` : `${days}d`;
  }

  const total = Math.floor(remainingMs / 1000);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

export function useCampaignCountdown(expiresAt: string | null): string | null {
  const [label, setLabel] = useState<string | null>(null);

  useEffect(() => {
    if (!expiresAt) {
      setLabel(null);
      return;
    }
    const deadline = new Date(expiresAt).getTime();
    if (!Number.isFinite(deadline)) {
      setLabel(null);
      return;
    }

    const tick = () => setLabel(formatCampaignCountdown(deadline - Date.now()));
    tick();
    const period = deadline - Date.now() >= HOURS_ONLY_BELOW_MS ? 60_000 : 1_000;
    const timer = window.setInterval(tick, period);
    return () => window.clearInterval(timer);
  }, [expiresAt]);

  return label;
}
